import "./style.scss"

export default function HealthWarning () {

    return (
        <div className="health-warning">
          <p>Rauchen ist tödlich.</p>
        </div>
    )
}